import { Component, Element, h, Host } from '@stencil/core';

export interface AhaTooltipDefaultTrigger extends HTMLAhaTooltipDefaultTriggerElement {}

@Component({
  tag: 'aha-tooltip-default-trigger',
  styleUrl: 'aha-tooltip-default-trigger.css',
  shadow: true,
})
export class AhaTooltipDefaultTrigger {
  @Element() host!: HTMLAhaTooltipDefaultTriggerElement;
  render() {
    return (
      <Host>
        <fa-icon class="default-icon fa-regular fa-question-circle"></fa-icon>
      </Host>
    );
  }
}
